import { useEffect } from "react";
import { useNavigate } from "react-router";
import { clearNavigationStack } from "../../router/navigationUtils";

export function useGlobalKeyboardShortcuts() {
  const navigate = useNavigate();

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.altKey && event.key === 'Home') {
        event.preventDefault();
        navigate('/');
        return;
      }

      if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.key === 'H') {
        event.preventDefault();
        clearNavigationStack();
        navigate('/');
        return;
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);
}
